export default __webpack_public_path__ + "static/media/48.5d0ece6a.png";